// extracted by mini-css-extract-plugin
module.exports = {"Warning":"NotFound_Warning__OgSI3"};